export default __webpack_public_path__ + "static/media/App.1b422068.png";